/**
 * StatusPill — small rounded pill with a dot + label. Port of `NBStatus`.
 *
 * Tones cover both workshop status (sold-out/on-track/soft/open) and the
 * generic health/availability vocabularies used by venues + teachers.
 */
export type StatusTone =
  | 'sold-out'
  | 'on-track'
  | 'soft'
  | 'open'
  | 'mocked'
  | 'healthy'
  | 'watch'
  | 'at-risk'
  | 'pto'
  | 'active';

const LABEL: Record<StatusTone, string> = {
  'sold-out': 'Sold out',
  'on-track': 'On track',
  soft: 'Soft',
  open: 'Open',
  mocked: 'Mocked',
  healthy: 'Healthy',
  watch: 'Watch',
  'at-risk': 'At risk',
  pto: 'PTO',
  active: 'Active',
};

const CLASS: Record<StatusTone, string> = {
  'sold-out': 'nb-status-soldout',
  'on-track': 'nb-status-ontrack',
  soft: 'nb-status-soft',
  open: 'nb-status-open',
  mocked: 'nb-status-mocked',
  healthy: 'nb-status-healthy',
  watch: 'nb-status-watch',
  'at-risk': 'nb-status-atrisk',
  pto: 'nb-status-pto',
  active: 'nb-status-active',
};

export interface StatusPillProps {
  tone: StatusTone;
  label?: string;
  /** Type size, for a caller whose own scale the pill has to sit inside —
   *  `WorkshopList` sizes it against the row. Omit for the standard pill. */
  fontSize?: number;
}

export function StatusPill({ tone, label, fontSize = 10.5 }: StatusPillProps) {
  return (
    <span className={`nb-pill ${CLASS[tone]}`} style={{ height: 20, fontSize, padding: '0 7px' }}>
      <i className="nb-pill-dot" />
      {label ?? LABEL[tone]}
    </span>
  );
}
